import { render, staticRenderFns } from "./BottomActionsBar.vue?vue&type=template&id=9051ed60&"
import script from "./BottomActionsBar.vue?vue&type=script&lang=js&"
export * from "./BottomActionsBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomActionsBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports